import React, { useContext, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useMutation } from "@apollo/client";
import { DELETE_POLE_FROM_SET } from "../../graphql/gqlPoleset";
import { AreYouSureModal } from "../../modals/AreYouSureModal";
import { T } from "../../components/T";
import { SnackbarContext } from "../../contexts/snackbarContext";

export const DeletePoleFromSetButton = ({
  polesetId,
  poleId,
}: {
  polesetId: string;
  poleId: string;
}) => {
  const [deletePoleFromSet] = useMutation(DELETE_POLE_FROM_SET);
  const [open, setOpen] = useState(false);
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);

  const onDelete = () => {
    deletePoleFromSet({ variables: { polesetId, poleId } })
      .then(() => {
        openSuccessSnackbar(<T str="Pole deleted" />);
      })
      .catch((error: Error) => {
        openErrorSnackbar(error.message || <T str="Something went wrong" />);
      })
      .finally(() => {
        setOpen(false);
      });
  };

  return (
    <>
      <IconButton
        sx={{ "&:hover": { color: "error.main" } }}
        onClick={() => setOpen(true)}
      >
        <DeleteIcon />
      </IconButton>

      <AreYouSureModal
        title={<T str="Delete pole" />}
        question={
          <T str="Are you sure you want to delete this pole from the set? This action cannot be undone." />
        }
        confirm={<T str="Delete" />}
        onConfirm={onDelete}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};
